import { useSyncExternalStore } from 'react';
import { MenuListItem } from '@/shared/components/export';
import effectivePermissionsService, {
  EffectivePermissionsMode,
} from '@/core/permissions/effective-permissions-service';
import { Permissions } from '@/core/permissions/permissions';

function formatAlphaPermissionLabel(permission: string): string {
  const suffix = permission.replace(Permissions.ALPHA_ACCESS, '');

  if (!suffix) return 'Alpha Features';

  return suffix
    .replace(/^:/, '')
    .split('-')
    .map(word => word.charAt(0).toUpperCase() + word.slice(1))
    .join(' ');
}

const MODES: { key: EffectivePermissionsMode; label: string }[] = [
  { key: 'production', label: 'Production mode' },
  { key: 'preproduction', label: 'Pre-production mode' },
];

/** Items for a "Toggle features" page in a MenuList, or null if the user has no alpha permissions. */
export function useToggleFeaturesMenuItems(): MenuListItem[] | null {
  const override = useSyncExternalStore(
    effectivePermissionsService.subscribe,
    effectivePermissionsService.getOverride,
  );
  const alphaPermissions = [...effectivePermissionsService.getRealAlphaPermissions()].sort((a, b) =>
    formatAlphaPermissionLabel(a).localeCompare(formatAlphaPermissionLabel(b)),
  );

  if (!alphaPermissions.length) return null;

  return MODES.map(mode => ({
    key: mode.key,
    label: mode.label,
    selected: override.mode === mode.key,
    onSelect: () => effectivePermissionsService.setMode(mode.key),
    nested:
      mode.key === 'preproduction'
        ? alphaPermissions.map(permission => ({
            key: permission,
            label:
              permission === Permissions.PETRO_PIPELINES_PLUS
                ? 'Petro Plus'
                : formatAlphaPermissionLabel(permission), // formatAlphaPermissionLabel(permission),
            selected:
              override.mode === 'preproduction' &&
              !override.disabledAlphaPermissions.includes(permission),
            disabled: override.mode !== 'preproduction',
            onSelect: () =>
              effectivePermissionsService.setAlphaPermissionEnabled(
                permission,
                override.disabledAlphaPermissions.includes(permission),
              ),
          }))
        : undefined,
  }));
}
